import { MarkerIconType } from "@ryde/shared";
import { redMui, rydeColors } from "@ryde/theme";

interface IResolveStationPinAppearanceArgs {
  /** Flag pin — a pickup point or an official station — rather than the house used for a home address. */
  isFlagVariant: boolean;
  isSelected: boolean;
  /** Called out ahead of selection; the passengers map uses it for the station just added. */
  isHighlighted?: boolean;
}

export interface IStationPinAppearance {
  type: MarkerIconType;
  color: string;
}

/**
 * Pin type and colour for a station marker.
 *
 * Shared because the passengers and stations maps drew the same pins from the same four colours and only
 * disagreed on what the flag meant — a pickup point on one, an official station on the other. Each held its
 * own set of pre-built Leaflet `DivIcon`s to say it; with an SVG pin taking type and colour as props it is
 * one lookup for both.
 */
export const resolveStationPinAppearance = ({
  isFlagVariant,
  isSelected,
  isHighlighted,
}: IResolveStationPinAppearanceArgs): IStationPinAppearance => {
  const type = isFlagVariant ? MarkerIconType.Flag : MarkerIconType.Home;

  // Highlight yields to selection: once the user picks the station, the selected colour takes over.
  if (isHighlighted && !isSelected) {
    return { type, color: redMui.A400 };
  }

  if (isSelected) {
    return { type, color: rydeColors.orange };
  }

  return {
    type,
    color: isFlagVariant ? rydeColors.venetianNights : rydeColors.electricPink,
  };
};
